export const PERMISSION_USER_READ = "user-read";
export const PERMISSION_USER_WRITE = "user-write";
export const PERMISSION_SUPPORTED_METHOD_READ = "supported-payment-method-read";
export const PERMISSION_SUPPORTED_METHOD_WRITE = "supported-payment-method-write";
export const PERMISSION_SMS_TRANSACTION_READ = "sms-transaction-read";
export const PERMISSION_SMS_TRANSACTION_WRITE = "sms-transaction-write";
export const PERMISSION_PRODUCT_READ = "product-read";
export const PERMISSION_PRODUCT_WRITE = "product-write";
export const PERMISSION_ADDRESS_READ = "address-read";
export const PERMISSION_ADDRESS_WRITE = "address-write";
export const PERMISSION_LOCATION_READ = "location-read";
export const PERMISSION_LOCATION_WRITE = "location-write";
export const PERMISSION_LOCATION_DELETE = "location-delete";
export const PERMISSION_BILL_HISTORY_READ = "bill-history-read";
export const PERMISSION_BILL_HISTORY_WRITE = "bill-history-write";
export const PERMISSION_BILL_READ = "bill-read";
export const PERMISSION_BILL_WRITE = "bill-write";
export const PERMISSION_EXPENSE_READ = "expense-read";
export const PERMISSION_EXPENSE_WRITE = "expense-write";
export const PERMISSION_EXPENSE_COMPLETION = "expense-completion";
export const PERMISSION_EXPENSE_HISTORY_READ = "expense-history-read";
export const PERMISSION_QUOTATION_WRITE = 'quotation-write';
export const PERMISSION_QUOTATION_READ = 'quotation-read';
export const PERMISSION_QUOTATION_DELETE = 'quotation-delete';
export const PERMISSION_QUOTATION_EXPORT = 'quotation-export';

export const PERMISSION_TECHNICIAN_READ = "technician-read";
export const PERMISSION_TECHNICIAN_WRITE = "technician-write";
export const PERMISSION_TOP_UP = "top-up";
export const PERMISSION_BILL_COMPLETION = "bill-completion";
export const PERMISSION_BILL_COMPLETION_DISABLE_DISCOUNT_PAYMENT =
  "bill-completion-disable-discount-payment";
export const PERMISSION_BILL_COMPLETION_DISABLE_PARTIAL_PAYMENT =
  "bill-completion-disable-partial-payment";
export const PERMISSION_BILL_COMPLETION_DISABLE_WHISH_TO_WHISH_PAYMENT =
  "bill-completion-disable-whish-to-whish-payment";
